"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.existsWallet = exports.getWallets = exports.updateWalletRequisites = exports.listOperations = exports.updateWalletContract = exports.updateWallet = exports.getWalletRequisites = exports.getWalletLoyaltyStatistics = exports.getWalletBalance = exports.createWallet = exports.listWallets = exports.getReportingDocumentFileMeta = exports.listReportingDocument = exports.getInvoiceFileMeta = exports.issueInvoice = exports.listInvoices = exports.client = void 0;
var axios_1 = __importDefault(require("@vtblife/axios"));
exports.client = axios_1.default.create();
exports.client.defaults.paramsSerializer = encode;
exports.client.defaults.baseURL = "/api";
function listInvoices(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/invoices",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.listInvoices = listInvoices;
function issueInvoice(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/billing/v1/invoices",
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.issueInvoice = issueInvoice;
function getInvoiceFileMeta(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/invoices/".concat(urlParams.invoiceId, "/file_meta"),
                        data: {},
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getInvoiceFileMeta = getInvoiceFileMeta;
function listReportingDocument(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/reporting_documents",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.listReportingDocument = listReportingDocument;
function getReportingDocumentFileMeta(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/reporting_documents/file_meta",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getReportingDocumentFileMeta = getReportingDocumentFileMeta;
function listWallets(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.listWallets = listWallets;
function createWallet(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/billing/v1/wallets",
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.createWallet = createWallet;
function getWalletBalance(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets/balance",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getWalletBalance = getWalletBalance;
function getWalletLoyaltyStatistics(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets/loyalty_statistics",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getWalletLoyaltyStatistics = getWalletLoyaltyStatistics;
function getWalletRequisites(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets/payout_requisites",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getWalletRequisites = getWalletRequisites;
function updateWallet(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/billing/v1/wallets/".concat(urlParams.walletId),
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.updateWallet = updateWallet;
function updateWalletContract(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/billing/v1/wallets/".concat(urlParams.walletId, "/contract"),
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.updateWalletContract = updateWalletContract;
function listOperations(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets/".concat(urlParams.walletId, "/operations"),
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.listOperations = listOperations;
function updateWalletRequisites(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var data = _b.data, urlParams = _b.urlParams, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "post",
                        url: "/billing/v1/wallets/".concat(urlParams.walletId, "/payout_requisites"),
                        data: data,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.updateWalletRequisites = updateWalletRequisites;
function getWallets(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets:all",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getWallets = getWallets;
function existsWallet(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var result;
        var params = _b.params, headers = _b.headers, cancelToken = _b.cancelToken, baseURL = _b.baseURL;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, exports.client)({
                        method: "get",
                        url: "/billing/v1/wallets:exists",
                        data: {},
                        params: params,
                        headers: headers,
                        cancelToken: cancelToken,
                        baseURL: baseURL,
                    })];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.existsWallet = existsWallet;
// @TODO: move to @vtblife/api-publisher after merge
// copied from https://github.com/Gozala/querystring/blob/8c9e090786d72db3172ad2c342096c2b42cedb2d/encode.js
function encode(obj) {
    var sep = "&";
    var eq = "=";
    var name = "";
    if (obj === null) {
        obj = undefined;
    }
    if (typeof obj === "object") {
        return Object.keys(obj)
            .map(function (k) {
            var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
            if (Array.isArray(obj[k])) {
                return obj[k]
                    .map(function (v) {
                    return ks + encodeURIComponent(stringifyPrimitive(v));
                })
                    .join(sep);
            }
            else {
                return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
            }
        })
            .filter(Boolean)
            .join(sep);
    }
    if (!name) {
        return "";
    }
    return (encodeURIComponent(stringifyPrimitive(name)) +
        eq +
        encodeURIComponent(stringifyPrimitive(obj)));
}
function stringifyPrimitive(v) {
    switch (typeof v) {
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
}
